import React from 'react';

import { Text } from '@zillow/constellation';

// styles
import { StyledMockUserNavDiv } from './style';
import type { Brand } from '../../interfaces/brand';
import type { User } from '../../interfaces/user';

interface MockUserNavProps {
  brand: Brand | string;
  userModel: User | null;
}
export default function MockUserNav(props: MockUserNavProps): JSX.Element {
  const { userModel, brand } = props;
  const { email, userToken } = userModel ?? {};

  const content = ' | brand: ' + brand + ' | token: ' + userToken + ' | email: ' + email;
  return (
    <StyledMockUserNavDiv data-testid="MockUserNav">
      <Text fontType="bodySmallHeading">Mocked User</Text>
      <Text fontType="body">{content}</Text>
    </StyledMockUserNavDiv>
  );
}
